// extracted by mini-css-extract-plugin
export default {"block":"LinkImg_block__7dUUZ","img":"LinkImg_img__R0OW5","catalog_text":"LinkImg_catalog_text__XsJh5","card":"LinkImg_card__Z+IsD"};